import { connect } from 'react-redux'
import NavBar from './presentational'
import { isGranted } from 'views/enhancers/withSecurity'

const mapStateToProps = (state) => ({
  // location: state.router.location,
  authenticated: state.authentication.authenticated && !!state.profile.payload['@id'],
  isGranted: (adminRequired, types) => isGranted(state.security, adminRequired, types),
  userType: state.security.type,
  accessWhiteLabel:
    state.profile.fetch.loading ||
    Boolean(
      (state.profile.payload || {}).accessCourierGeolocation ||
        (state.profile.payload || {}).accessTimeManagement ||
        (state.profile.payload || {}).accessOperationsMonitoring ||
        (state.profile.payload || {}).accessDropoffConfiguration ||
        (state.profile.payload || {}).accessCustomLandingPage ||
        (state.profile.payload || {}).accessProfitabilityCalculator,
    ),
  canDropOffDeliveries: state.profile.fetch.loading || Boolean((state.profile.payload || {}).canDropOffDeliveries),
})

export default connect(mapStateToProps, null)(NavBar)
